import React from 'react';
import {formatAcuities, formatRetinos} from "../../../Appointments/Mesures/mesure_components/mesures";
import {Side, TypesMesures} from "../../../Shared/Enums/Enums";
import mesure_types from "../../../Appointments/Mesures/mesure_components/MesureTypes.json";
import MesureStore from "../../../Appointments/Mesures/MesureStore";
import {VANESSA_LABARBE_ID} from "../../../Shared/Helper";
import {t} from "../../../I18n/i18n";

const AppointmentMeasures = ({appointment}) => {
    const sortedMesures = appointment.measures ?
        Object.values(TypesMesures)
            .map((type) => appointment.measures.find((m) => m.title === type))
            .filter((m) => m)
        : [];

    const renderTension = (measure) => {
        return <div className="fr valign-wrapper card grey lighten-4 z-depth-0" style={{paddingBlock: 0, borderRadius: 5}}>
            <div style={{width: "150px"}}>{measure.title}</div>
            <div className="fc" style={{gap: 0}}>
                {measure.od_tension ?
                    <div style={{margin: 0}}>OD : {measure.od_tension < 0 ? "NM" : measure.od_tension}</div> : null}
                {measure.og_tension ?
                    <div style={{margin: 0}}>OG : {measure.og_tension < 0 ? "NM" : measure.og_tension}</div> : null}
            </div>
        </div>

    }

    const renderPachymetry = (measure) => {
        return <div className="fr valign-wrapper card grey lighten-4 z-depth-0" style={{paddingBlock: 0, borderRadius: 5}}>
            <div style={{width: "150px"}}>{measure.title}</div>
            <div className="fc" style={{gap: 0}}>
                {measure.od_pachymetrie ? <div style={{margin: 0}}>OD : {measure.od_pachymetrie} µm</div> : null}
                {measure.og_pachymetrie ? <div style={{margin: 0}}>OG : {measure.og_pachymetrie} µm</div> : null}
            </div>
        </div>
    }

    const renderKeratometry = (measure) => {
        if (MesureStore.orthoptiste.id === VANESSA_LABARBE_ID) {
            return <div className="fr valign-wrapper card grey lighten-4 z-depth-0" style={{paddingBlock: 0, borderRadius: 5}}>
                <div style={{width: "150px"}}>{measure.title}</div>
                <div className="fc" style={{gap: 0}}>
                    {measure.od_radius_1 && measure.od_radius_2 && measure.od_degree ?
                        <div>K1 {measure.od_radius_1} K2 {measure.od_radius_2} {t("ACTIVE_TABS.AXIS")} {measure.od_degree}°</div>: null}
                    {measure.og_radius_1 && measure.og_radius_2 && measure.og_degree ?
                        <div>K1 {measure.og_radius_1} K2 {measure.og_radius_2} {t("ACTIVE_TABS.AXIS")} {measure.og_degree}°</div>: null}
                </div>
            </div>
        } else {
            return <div className="fr valign-wrapper card grey lighten-4 z-depth-0" style={{paddingBlock: 0, borderRadius: 5}}>
                <div style={{width: "150px"}}>{measure.title}</div>
                <div className="fc" style={{gap: 0}}>
                    {measure.od_radius_1 && measure.od_radius_2 && measure.od_degree ?
                        <div>R1 {measure.od_radius_1} R2 {measure.od_radius_2} D {measure.od_degree}°</div>: null}
                    {measure.og_radius_1 && measure.og_radius_2 && measure.og_degree ?
                        <div>R1 {measure.og_radius_1} R2 {measure.og_radius_2} D {measure.og_degree}°</div>: null}
                </div>
            </div>
        }
    }

    const renderMesure = (measure) => {
        return <div className="fr valign-wrapper card grey lighten-4 z-depth-0" style={{paddingBlock: 0, borderRadius: 5}}>
            <div style={{width: "150px"}}>{measure.title}</div>
            <div className="fc" style={{gap: 0}}>
                <div style={{margin: 0}}>
                    OD : {formatRetinos(measure, Side.RIGHT)} {formatAcuities(measure, Side.RIGHT, true)}
                </div>
                <div style={{margin: 0}}>
                    OG : {formatRetinos(measure, Side.LEFT)} {formatAcuities(measure, Side.LEFT, true)}
                </div>
            </div>
        </div>
    }

    const renderBino = (binoMeasure) => {
        return <div className="fr valign-wrapper card grey lighten-4 z-depth-0" style={{paddingBlock: 0, borderRadius: 5}}>
            <div style={{width: "150px"}}>{binoMeasure.title}</div>
            <div className="fc" style={{gap: 0}}>
                <div style={{margin: 0}}>
                    {binoMeasure.bino_data_text ? binoMeasure.bino_data_text : ""}
                </div>
            </div>
        </div>
    }

    function chooseMeasureRender(measure) {
        const measure_type = (measure) => mesure_types.find(type => TypesMesures[type.name] === measure.title)

        switch (measure.title) {
            case TypesMesures.TENSION :
                return renderTension(measure);
            case TypesMesures.PACHYMETRY :
                return renderPachymetry(measure);
            case TypesMesures.KERATOMETRY :
                return renderKeratometry(measure);
            default :
                if(measure_type(measure)?.only_bino){
                    return renderBino(measure)
                } else {
                    return renderMesure(measure);
                }
        }
    }

    return <div className="fc">
        {sortedMesures && sortedMesures.length > 0 && <div><b>Mesures :</b></div>}
        {sortedMesures.map((measure, index) => {
            return <div key={index}>
                {chooseMeasureRender(measure)}
            </div>
        })}
    </div>
}

export default AppointmentMeasures;